/**
 * The rider screens' small helpers: how a job is paid, the offer clock, and
 * which accepted job this session has already opened or left. The jobs
 * themselves come from InGo's API (`src/api/riderWork.js`, `riderWork.js`).
 */

/** @param {string | null | undefined} labelOrMethod */
export function isWalletCustomerPayment(labelOrMethod) {
  const s = String(labelOrMethod || '')
    .toLowerCase()
    .trim();
  return s === 'wallet' || s === 'wallet payment' || s.includes('wallet');
}

/** @param {string | null | undefined} labelOrMethod */
export function isCashCustomerPayment(labelOrMethod) {
  const s = String(labelOrMethod || '')
    .toLowerCase()
    .trim();
  return s === 'cod' || s === 'cash payment' || s === 'cash on delivery' || s === 'cash';
}

/**
 * How long a still-open offer may ring again: once per `OFFER_RING_CYCLE_MS`,
 * for at most 30 minutes after it was made (the provider's re-ring).
 */
export const OPEN_OFFER_MAX_AGE_MS = 30 * 60_000;

/**
 * One ring cycle: how long a ring sounds, and the countdown bar's full width
 * for an offer that does not carry its own window.
 */
export const OFFER_RING_CYCLE_MS = 120_000;

export function formatOfferTime(iso) {
  if (!iso) return '—';
  try {
    return new Date(iso).toLocaleString(undefined, { dateStyle: 'short', timeStyle: 'short' });
  } catch {
    return String(iso);
  }
}

const DRIVER_LEFT_ACCEPTED_DELIVERY_KEY = 'driver_left_accepted_delivery';
const DRIVER_AUTO_OPENED_ACCEPTED_KEY = 'driver_auto_opened_accepted';

function acceptedDeliverySessionKey(table, id) {
  return `${String(table || '')}:${String(id || '')}`;
}

/** The rider tapped Back from the active delivery screen: do not auto-open it again. */
export function markDriverLeftAcceptedDelivery(table, id) {
  const k = acceptedDeliverySessionKey(table, id);
  if (!k || k === ':') return;
  try {
    sessionStorage.setItem(`${DRIVER_LEFT_ACCEPTED_DELIVERY_KEY}:${k}`, '1');
  } catch {
    /* ignore */
  }
}

export function driverHasLeftAcceptedDelivery(table, id) {
  const k = acceptedDeliverySessionKey(table, id);
  if (!k || k === ':') return false;
  try {
    return sessionStorage.getItem(`${DRIVER_LEFT_ACCEPTED_DELIVERY_KEY}:${k}`) === '1';
  } catch {
    return false;
  }
}

export function markDriverAutoOpenedAcceptedDelivery(table, id) {
  const k = acceptedDeliverySessionKey(table, id);
  if (!k || k === ':') return;
  try {
    sessionStorage.setItem(`${DRIVER_AUTO_OPENED_ACCEPTED_KEY}:${k}`, '1');
  } catch {
    /* ignore */
  }
}

export function driverHasAutoOpenedAcceptedDelivery(table, id) {
  const k = acceptedDeliverySessionKey(table, id);
  if (!k || k === ':') return false;
  try {
    return sessionStorage.getItem(`${DRIVER_AUTO_OPENED_ACCEPTED_KEY}:${k}`) === '1';
  } catch {
    return false;
  }
}

